<div class="co-pilot">
    <b-modal v-model="isModalActive">
        <div class="call-me-modal">
            <div class="call-me-modal-content">
                <p>Your request has been submitted, a member of the team will call you shortly </p>
                <br>
                <p style="font-size: 0.8rem;">(please note our working hours are Monday to Friday 8am-5pm)</p>
            </div>
            <div class="close-modal">
                <b-button style="border-radius: 25px;" @click="isModalActive = false" type="is-danger">Close</b-button>
            </div>
        </div>
    </b-modal>
    <div class="top-banner" v-if="!notificationClosedByUser && notificationBannerActive">
        On Friday 24.05.2024 from 4pm, our systems will undergo maintenance to improve reliability, BA Co-Pilot will be
        unavailable for up to 24 hours. <br> We thank you for your understanding.
        <span class="close-button" @click="closeNotificationBanner">x</span>
    </div>
    <sign-in :email-only="emailOnly">
        <overlay v-if="overlay !== null" :message="overlay.title" :state="'LOADING'" :styles="overlayStyles"></overlay>
        <template v-if="!isLoading" style="height: 100%; width: 100%;">
            <error></error>
            <navigation-bar @search="filterProjects" app-type="co-pilot" :profileIconColor="profileIconColor" :menuButtonIconColor="'#000'" :show-feedback-link="false">
                <template #titleText>
                    {{ companyName }}
                </template>
                <template #iconsContainer>
                    <!--                    <router-link v-if="isExternalUser === false && isDev" to="primary-cost-estimate" class="link-icon">-->
                    <!--                        <div class="nav-button">-->
                    <!--                            <fa icon="calculator" size="2x" :style="{color: profileIconColor}"></fa>-->
                    <!--                            <div class="nav-button-text">PCE</div>-->
                    <!--                        </div>-->
                    <!--                    </router-link>-->

                    <router-link to="overview" class="link-icon">
                        <div class="nav-button">
                            <fa icon="compass-drafting" size="xl" :style="{color: profileIconColor}"></fa>
                            <div class="nav-button-text">Projects</div>
                        </div>
                    </router-link>

                    <router-link to="profile" class="link-icon">
                        <div class="nav-button">
                            <fa icon="user" size="xl" :style="{color: profileIconColor}"></fa>
                            <div class="nav-button-text">Profile</div>
                        </div>
                    </router-link>
                    <template v-if="isExternalUser">
                        <b-dropdown aria-role="menu" :triggers="['click']" position="is-bottom-left" append-to-body>
                            <template #trigger="{ active }">
                                <div class="nav-button">
                                    <fa :icon="iconForCallbackButton" size="xl" :style="{ color: profileIconColor }"
                                        :spin="isSaving"></fa>
                                    <div class="nav-button-text">{{ requestCallbackButtonText }}</div>
                                </div>
                            </template>
                            <b-dropdown-item v-for="(reason, index) in reasonsForCall" aria-role="menuitem">
                                <div @click="requestCallback(reason)">
                                    {{ reason }}
                                </div>
                            </b-dropdown-item>

                        </b-dropdown>
                    </template>

                    <a v-if="isExternalUser === false">
                        <div class="nav-button" @click="resetCompany">
                            <fa icon="rotate-right" size="xl" :style="{color: profileIconColor}"></fa>
                            <div class="nav-button-text">Reset C</div>
                        </div>
                    </a>
                </template>
            </navigation-bar>
            <div class="container app-container">
                <router-view></router-view>
            </div>
            <!--            <router-link to="project-submission" v-if="($route.path !== '/project-submission' && company && isExternalCompany) || isDev" id="expandableButton"-->
            <!--               class="floating-button">-->
            <!--                <span class="plus-icon">+</span>-->
            <!--                <span class="submit-text">Submit Project</span>-->
            <!--            </router-link>-->
            <a href="https://projectestimator.co.uk/submit-your-project/" id="expandableButton"
               class="floating-button">
                <span class="plus-icon">+</span>
                <span class="submit-text">Submit Project</span>
            </a>
        </template>
    </sign-in>
</div>
